import { useCallback } from 'react';

export default function useAuthActions(dispatch) {
  const loginSucceeded = useCallback(
    ({
      username,
      clientName,
      clientId,
      scopes,
      userId,
      sessionToken,
      isStaff,
      authenticated,
    }) => {
      dispatch({
        type: 'loginSucceeded',
        payload: {
          username,
          clientName,
          clientId,
          scopes,
          userId,
          sessionToken,
          isStaff,
          authenticated,
        },
      });
    },
    [dispatch]
  );
  const setSessionToken = useCallback(
    ({ sessionToken }) => {
      dispatch({
        type: 'setSessionToken',
        payload: { sessionToken },
      });
    },
    [dispatch]
  );
  const logout = useCallback(() => {
    dispatch({
      type: 'logout',
      payload: {},
    });
  }, [dispatch]);

  return {
    loginSucceeded,
    logout,
    setSessionToken,
  };
}
